var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-row", [
        _c(
          "div",
          { staticStyle: { padding: "10px 25px" } },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticStyle: { padding: "10px" },
                attrs: { model: _vm.form, inline: true }
              },
              [
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "包裹号", clearable: "" },
                      model: {
                        value: _vm.form.package_no,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "package_no", $$v)
                        },
                        expression: "form.package_no"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "货号", clearable: "" },
                      model: {
                        value: _vm.form.goods_no,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "goods_no", $$v)
                        },
                        expression: "form.goods_no"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "款号", clearable: "" },
                      model: {
                        value: _vm.form.goods_kh,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "goods_kh", $$v)
                        },
                        expression: "form.goods_kh"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "SKU编号", clearable: "" },
                      model: {
                        value: _vm.form.sku,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "sku", $$v)
                        },
                        expression: "form.sku"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch }
                      },
                      [_vm._v(" 查询 ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "0" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.handleListExport }
                      },
                      [_vm._v("导出列表\n          ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.listData.length > 0
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading"
                    }
                  ],
                  key: "table1",
                  attrs: {
                    data: _vm.listData,
                    border: "",
                    "max-height": "400px"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "img",
                      label: "商品图片",
                      align: "center",
                      width: "90"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    { name: "viewer", rawName: "v-viewer" }
                                  ],
                                  staticStyle: {
                                    width: "60px",
                                    height: "60px",
                                    overflow: "hidden",
                                    cursor: "pointer"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticStyle: {
                                      width: "160%",
                                      height: "160%"
                                    },
                                    attrs: { src: row.main_img }
                                  })
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      866233361
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_name",
                      label: "商品名称",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_no",
                      label: "货号",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "goods_kh",
                      label: "款号",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sku",
                      label: "SKU",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "co_val",
                      label: "颜色",
                      align: "center",
                      width: "110"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "si_val",
                      label: "尺码",
                      align: "center",
                      width: "110"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "package_no",
                      label: "包裹号",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "in_num",
                      label: "一手入库数（当前实时）",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "num",
                      label: "商家配货数",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "check_goods_num",
                      label: "当前入库件数差异",
                      align: "center"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c("NumColorCell", {
                                attrs: { num: row.in_feedback_num || "" }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3660443464
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.listData.length > 0
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading"
                    }
                  ],
                  key: "table2",
                  attrs: {
                    data: _vm.totalData,
                    border: "",
                    "show-header": false
                  }
                },
                [
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        prop: "",
                        label: "",
                        align: "center",
                        width: "90"
                      }
                    },
                    [_vm._v("\n        合计\n      ")]
                  ),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: "",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: "",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: "",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: "",
                      align: "center",
                      width: "160"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: "",
                      align: "center",
                      width: "110"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: "",
                      align: "center",
                      width: "110"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "", align: "center", width: "160" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "in_num", align: "center", width: "160" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "num", align: "center", width: "160" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "in_feedback_num", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c("NumColorCell", {
                                attrs: { num: row.in_feedback_num || "" }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3660443464
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.listData.length <= 0
            ? _c("div", { staticClass: "flex-center" }, [_vm._v("暂无数据～")])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-091f1600", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-091f1600","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/receiveGoods/StockVarianceProcess/components/InventoryByLackGoods.vue
// module id = null
// module chunks = 